import React from 'react';
import PropTypes from 'prop-types';
import Check from 'src/svgs/status/check.svg';
import {button, primary} from 'src/styles/modules/button.module.scss';
import {icon, check, smsConfirmedHead, smsConfirmedText} from 'src/pages/reportIssue/components/styles.module.scss';
import {formatPhoneNumber} from 'src/shared/utils/formatPhoneNumber';

export const SmsConfirmedScreen = ({
  statusCenterUrl,
  smsNumber,
}) =>
  <>
    <Check className={`${icon} ${check}`} />
    <h1 className={smsConfirmedHead}>We&apos;re on it!</h1>
    <p className={smsConfirmedText}>We&apos;ll send a text with more details to <strong>{formatPhoneNumber(smsNumber)}</strong> in the next 15 minutes. Thanks for your patience.</p>
    <a href={statusCenterUrl} className={`${button} ${primary}`} rel="noopener">Visit Status Center</a>
  </>;

SmsConfirmedScreen.propTypes = {
  statusCenterUrl: PropTypes.string.isRequired,
  smsNumber: PropTypes.string.isRequired,
};
